import * as React from "react";
import Section from "../../../core/Section";

export default class AccessDenied extends React.Component<any, any> {
  render() {
    return (
      <Section className="view-reports">
        <h1>Uh Oh</h1>
        <h3>
          Looks like you might not have access to this page, please contact
          support for more information
        </h3>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/common/components/Permissions/index.tsx